module.exports = __webpack_public_path__ + "static/media/295340.8b67c337.png";